type SectionHeaderProps = {
  title: string
  description?: string
}

export function SectionHeader({ title, description }: SectionHeaderProps) {
  return (
    <div className="pl-1">
      <div className="flex items-center gap-1">
        <h2 className="text-heading-md text-strong">{title}</h2>
      </div>
      {description && <p className="text-body-sm text-subtle">{description}</p>}
    </div>
  )
}
